module.exports = __webpack_public_path__ + "static/media/skyBackground.348de5c8.jpg";